import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Checkbox, Row, Col, Pagination } from "antd";
import { RoomRequisitionList } from "./RoomRequisitionList";
import { ApprovalReasonModal } from "../../common/ApprovalReasonModal";
import "../../../App.css";
import {
  Status,
  StatusByHexColor,
} from "../../../components/model/common/Status";
import { useTranslation } from "react-i18next";

export default function RoomRequisitionCancellationApprovalForm({
  isLoading,
  data,
  selectedItems,
  onAdd,
  onView,
  onApproved,
  onRejected,
  onItemSelected,
  setCurrentYear,
  currentYear,
  pagination,
  setPagination,
  resetPagination,
}) {
  const { t } = useTranslation();
  const [showReasonForm, setShowReasonForm] = useState(false);
  const [tempItem, setTempItem] = useState();

  function submitRejectReason(reason) {
    setShowReasonForm(false);
    if (tempItem) {
      //reject single item
      onRejected([tempItem], reason);
    } else {
      //reject multiple items
      onRejected(selectedItems, reason);
    }
  }

  function rejectCancelledRoomRequisition(selectedRoomRequisition) {
    setTempItem(selectedRoomRequisition);
    setShowReasonForm(true);
  }

  function rejectCancelledRoomRequisitions() {
    setTempItem(null);
    setShowReasonForm(true);
  }

  function getListActions(item) {
    return [
      <div key>
        <Row>
          <Col xs={24} sm={24} md={24} lg={16} xl={16}>
            <div
              style={{
                float: "left",
                fontStyle: "italic",
                marginLeft: "30px",
                paddingTop: "5px",
                textAlign: "left",
                lineHeight: "1.1",
                wordBreak: "break-all",
                paddingBottom: "10px",
                color: StatusByHexColor[item.Status],
              }}
            >
              {Status[item.Status]}
              <br /> <b>{t("general.reason")}:</b> {item.Reason}
            </div>
          </Col>
          <Col xs={24} sm={24} md={24} lg={8} xl={8}>
            <Button
              type="default"
              size="default"
              style={{ marginRight: 10 }}
              onClick={() => rejectCancelledRoomRequisition(item)}
            >
              {t("general.reject")}
            </Button>
            <Button
              type="primary"
              size="default"
              onClick={() => onApproved([item])}
            >
              {t("general.approve")}
            </Button>
          </Col>
        </Row>
      </div>,
    ];
  }

  function selectAllItems(isSelected) {
    if (onItemSelected) {
      if (isSelected) {
        onItemSelected([...data]);
      } else {
        onItemSelected([]);
      }
    }
  }

  const footerElement = (footerValue, totalPagination) => (
    <Row>
      <Col span={2} style={{ paddingTop: "5px" }}>
        <Checkbox
          indeterminate={
            selectedItems.length && selectedItems.length < data.length
          }
          checked={selectedItems.length === data.length}
          onChange={(event) => selectAllItems(event.target.checked)}
        >
          {t("general.select_all")}
        </Checkbox>
      </Col>

      <Col span={22} style={{ textAlign: "right" }}>
        <Pagination
          style={{ display: "inline-flex", paddingRight: 10 }}
          defaultCurrent={pagination.current}
          current={pagination.current}
          total={totalPagination}
          onChange={onChangePagination}
          showTotal={(total) =>
            t("general.total") + ` ${total} ` + t("general.records")
          }
          defaultPageSize={pagination.pageSize}
          pageSize={pagination.pageSize}
        />
        {t("general.total")} :{" "}
        <b style={{ color: "#0070cc" }}>
          {data.length && data[0] ? data[0].FuncCurrSymb + " " : ""}
          {footerValue}
        </b>
        <Button
          type="default"
          style={{ marginRight: "5px", marginLeft: "10px" }}
          disabled={selectedItems.length === 0 || isLoading}
          onClick={rejectCancelledRoomRequisitions}
        >
          {t("general.reject")}
        </Button>
        <Button
          type="primary"
          disabled={selectedItems.length === 0 || isLoading}
          onClick={() => onApproved(selectedItems)}
        >
          {t("general.approve")}
        </Button>
      </Col>
    </Row>
  );

  function onChangePagination(page, pageSize) {
    setPagination({
      current: page,
      minIndex: (page - 1) * pageSize,
      maxIndex: page * pageSize,
      pageSize: pageSize,
    });
  }

  return (
    <div>
      <RoomRequisitionList
        isLoading={isLoading}
        data={data}
        onAdd={onAdd}
        onItemViewed={onView}
        isSelectable={true}
        selectedItems={selectedItems}
        onItemSelected={onItemSelected}
        onListActionsRendered={getListActions}
        footerElement={footerElement}
        setCurrentYear={setCurrentYear}
        currentYear={currentYear}
        pagination={pagination}
        resetPagination={resetPagination}
      />

      <ApprovalReasonModal
        isVisible={showReasonForm}
        reasonType={"Reject Cancellation Request"}
        onSaved={submitRejectReason}
        onCancelled={() => setShowReasonForm(false)}
      />
    </div>
  );
}

RoomRequisitionCancellationApprovalForm.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  data: PropTypes.array.isRequired,
  selectedItems: PropTypes.array.isRequired,
  onAdd: PropTypes.func.isRequired,
  onView: PropTypes.func.isRequired,
  onApproved: PropTypes.func.isRequired,
  onRejected: PropTypes.func.isRequired,
  onItemSelected: PropTypes.func.isRequired,
  setCurrentYear: PropTypes.func.isRequired,
  currentYear: PropTypes.number.isRequired,
  pagination: PropTypes.object.isRequired,
  setPagination: PropTypes.func.isRequired,
  resetPagination: PropTypes.func.isRequired,
};
